module.exports = __webpack_public_path__ + "img/avatar-77.43dc296c.png";